module.exports = __webpack_public_path__ + "img/goto-brand.5eb6aeac.svg";